module.exports = __webpack_public_path__ + "fab5521d65d03d98e5b0d98252a568d8.png";